import React, {useState} from "react";
import PropTypes from "prop-types";
import NameValueLabels from "../../Components/NameValueLabels";
import {KnownItemPercentage} from "../KnownItemPercentage";
import AlertLink from "./AlertLink";
import {faIcons} from "../../../utils/iconConstants";


export const PreviousRunSummaryInformation = ({previousRun}) => {
    const [inHover, setHover] = useState(false);

    return <div className={'hover-tool-tip-div'} data-testid={"previous-run-summary-information-container"}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}>

        <i className={`${faIcons.infoCircle} previous-run-summary-icon-${previousRun.hasFailures ? "failure":"success"}`}
           data-testid={"previous-run-summary-icon"} />
        {inHover && <div className={'tooltip-contents'} data-testid={"tooltip-contents"}>
            <NameValueLabels
                containerClassName={'hover-tool-tip-div-hover'}
                labelValuePairs={[
                    {label: "Triggered By:", value: previousRun.triggeredBy},
                    {label: "Issue Count:", value: previousRun.normalizedRejectCount},
                    {label: "Alerts:", value: <AlertLink value={previousRun.alertIds}/>},
                    {label: "Known Item %:", value: <KnownItemPercentage original={previousRun}/>}
                ]}/>
        </div>}
    </div>;


}
PreviousRunSummaryInformation.propTypes = {previousRun: PropTypes.any};